module.exports = __webpack_public_path__ + "static/media/centro_medio_1.09b242f4.mp4";